var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniqueDesigns(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2055 27.5065L39.7469 28.9451L47.1229 36.4211L39.7469 43.8971L41.2055 45.3357L50 36.4211L41.2055 27.5065Z",
    fill: "#D3A143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2521 28.9451L8.79352 27.5065L0 36.4211L8.79352 45.3357L10.2521 43.8971L2.87715 36.4211L10.2521 28.9451Z",
    fill: "#D3A143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9994 4.66437H9.0006L3.2653 16.135L25 37.8697L46.7347 16.135L40.9994 4.66437ZM39.7329 6.71319L43.8305 14.9085H32.6974L31.3312 6.71319H39.7329ZM20.7456 6.71319H29.2544L30.6205 14.9085H19.3794L20.7456 6.71319ZM10.2671 6.71319H18.6688L17.3026 14.9085H6.16947L10.2671 6.71319ZM6.98479 16.9573H17.4324L22.6565 32.629L6.98479 16.9573ZM19.5912 16.9573H30.4089L25 33.1829L19.5912 16.9573ZM27.3435 32.629L32.5676 16.9573H43.0152L27.3435 32.629Z",
    fill: "#D3A143"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueDesigns);
export default __webpack_public_path__ + "static/media/uniqueDesigns.e901a5d699d8421a75b021727d2099af.svg";
export { ForwardRef as ReactComponent };